import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/dist/client/image-component.js");
